import { PickingSlide } from "./../enum/pickingSlide.enum";
import { Overview } from "./../enum/overview.enum";
import { MeasurementSystem } from "@doka/angular-core";

export class ConfigModel {
  static readonly CONFIG_KEYS: string[] = [
    "fontSize",
    "token",
    "pickingColumns",
    "pickingItemColumns",
    "returnColumns",
    "returnCustQtyColumns",
    "returnItemColumns",
    "returnSparePartColumns",
    "openReturnItemColumns",
    "transportOrderColumns",
    "reconColumns",
    "reconItemColumns",
    "reconSparePartColumns",
    "openItemColumns",
    "yardStockColumns",
    "returnDeliveryColumns",
    "returnDeliveryItemColumns",
    "returnDeliverySparepartColumns",
    "inboundOrderColumns",
    "inboundOrderItemColumns",
    "returnHighlighting",
    "overviewFirst",
    "overviewSecond",
    "overviewThird",
    "overviewFourth",
    "pickingSlide",
    "measurementSystem",
  ];
  fontSize: string = "standard";
  token?: string;
  pickingColumns: { value: string; size: string; display: boolean }[] = [
    { value: "salesIds", size: null, display: true },
    { value: "convertedDate", size: null, display: true },
    { value: "projectName", size: null, display: true },
    { value: "custName", size: null, display: true },
    { value: "p_id", size: null, display: true },
    { value: "commissionLocation", size: null, display: true },
    { value: "picker", size: null, display: true },
    { value: "projectNo", size: null, display: true },
    { value: "itemCount", size: null, display: true },
    { value: "weight", size: null, display: true },
    { value: "done", size: null, display: true },
    { value: "combinedText", size: null, display: true },
    { value: "locked", size: null, display: true },
  ];
  pickingItemColumns: { value: string; size: string; display: boolean }[] = [
    { value: "itemId", size: null, display: true },
    { value: "itemName", size: null, display: true },
    { value: "orderedNew", size: null, display: true },
    { value: "orderedUsed", size: null, display: true },
    { value: "pickedNew", size: null, display: true },
    { value: "pickedUsed", size: null, display: true },
    { value: "changes", size: null, display: true },
    { value: "salesId", size: null, display: true },
    { value: "combinedText", size: null, display: true },
  ];
  returnColumns: { value: string; size: string; display: boolean }[] = [
    { value: "locked", size: null, display: true },
    { value: "redeliveryType", size: null, display: true },
    { value: "t_id", size: null, display: true },
    { value: "convertedDate", size: null, display: true },
    { value: "pamstatus", size: null, display: true },
    { value: "pamplacenumber", size: null, display: true },
    { value: "additionaltext", size: null, display: true },
    { value: "rentalsitedescription", size: null, display: true },
    { value: "custname", size: null, display: true },
    { value: "tonnage1st", size: null, display: true },
    { value: "tonnage", size: null, display: true },
    { value: "projectno", size: null, display: true },
  ];
  returnCustQtyColumns: { value: string; size: string; display: boolean }[] = [
    { value: "ItemId", size: null, display: true },
    { value: "ItemName", size: null, display: true },
    { value: "InventSerialId", size: null, display: true },
    { value: "Invent", size: null, display: true },
    { value: "QtyCustPackingSlip", size: null, display: true },
    { value: "FirstSight", size: null, display: true },
    { value: "FirstSightSeen", size: null, display: true },
    { value: "AddedInApp", size: null, display: true },
  ];
  returnItemColumns: { value: string; size: string; display: boolean }[] = [
    { value: "ItemId", size: null, display: true },
    { value: "ItemName", size: null, display: true },
    { value: "SerialNumber", size: null, display: true },
    { value: "FirstSight", size: null, display: true },
    { value: "FirstSightSeen", size: null, display: true }, //Augesymbol
    { value: "Invent", size: null, display: true },
    { value: "QtyCustPackingSlip", size: null, display: true },
    { value: "Total", size: null, display: true }, // OK, Rec, Crap, CustCrap
    { value: "RedCatFinished", size: null, display: true },
    { value: "Qty_QualCat_OK", size: null, display: true },
    { value: "Qty_Pulled", size: null, display: true },
    { value: "Qty_QualCat_Repair", size: null, display: true },
    { value: "Qty_QualCat_RepairFinished", size: null, display: true },
    { value: "Qty_QualCat_Crap", size: null, display: true },
    { value: "Qty_QualCat_CustCrap", size: null, display: true },
    { value: "Qty_Cleaning", size: null, display: true },
    { value: "Qty_OwnConsumption", size: null, display: true },
    { value: "Qty_PlyWoodRepair", size: null, display: true },
    { value: "Qty_FrameRepair", size: null, display: true },
    { value: "AdditionalLineText", size: null, display: true },
    { value: "CouchAdditionalLineText", size: null, display: true },
    { value: "AddedInApp", size: null, display: true },
    { value: "IsCentralItem", size: null, display: true }, //Fadenkreuz
  ];
  returnSparePartColumns: { value: string; size: string; display: boolean }[] = [
    { value: "SuppItemId", size: null, display: true },
    { value: "SuppItemName", size: null, display: true },
    { value: "NewUsed", size: null, display: true },
    { value: "SalesUnit", size: null, display: true },
    { value: "CouchSalesQtyDoka", size: null, display: true },
    { value: "CouchSalesQty", size: null, display: true },
    { value: "Picked", size: null, display: true },
    { value: "ItemDamaged", size: null, display: true },
    { value: "ItemLack", size: null, display: true },
  ];
  openReturnItemColumns: { value: string; size: string; display: boolean }[] = [
    { value: "returnId", size: null, display: true },
    { value: "returnDate", size: null, display: true },
    { value: "pamplacenumber", size: null, display: true },
    { value: "ItemId", size: null, display: true },
    { value: "ItemName", size: null, display: true },
    { value: "Qty_QualCat_OK", size: null, display: true },
    { value: "Qty_QualCat_Repair", size: null, display: true },
    { value: "Qty_QualCat_RepairFinished", size: null, display: true },
    { value: "FirstSight", size: null, display: true },
    { value: "firstSightSeen", size: null, display: true },
  ];
  transportOrderColumns: { value: string; size: string; display: boolean }[] = [
    { value: "transportOrderId", size: null, display: true },
    { value: "convertedDepDate", size: null, display: true },
    { value: "carrierAccount", size: null, display: true },
    { value: "carrierName", size: null, display: true },
    { value: "chauffeur", size: null, display: true },
    { value: "containerCode", size: null, display: true },
    { value: "tansUnitCode1", size: null, display: true },
    { value: "tansUnitCode2", size: null, display: true },
    { value: "packageCount", size: null, display: true },
    { value: "itemCount", size: null, display: true },
    { value: "shipper", size: null, display: true },
    { value: "checkLocked", size: null, display: true },
    { value: "locked", size: null, display: true },
    { value: "combinedText", size: null, display: true },
    { value: "loadingMeter", size: null, display: true },
    { value: "done", size: null, display: true },
  ];
  reconColumns: { value: string; size: string; display: boolean }[] = [
    { value: "isLocked", size: null, display: true },
    { value: "canItemsBeAdded", size: null, display: true },
    { value: "reconditioningOrderIdentifier", size: null, display: true },
    { value: "plannedFinishDate", size: null, display: true },
    { value: "RECON_OVERALL", size: null, display: true },
    { value: "RECON_SPAREPART_OVERALL", size: null, display: true },
    { value: "countType", size: null, display: true },
    { value: "mobileReconditioningStatus", size: null, display: true },
    { value: "type", size: null, display: true },
    { value: "customer", size: null, display: true },
    { value: "netWeight", size: null, display: true },
    { value: "unloadingLocation", size: null, display: true },
  ];
  reconItemColumns: { value: string; size: string; display: boolean }[] = [
    { value: "articleImage", size: null, display: true },
    { value: "articleIdentifier", size: null, display: true },
    { value: "articleName", size: null, display: true },
    { value: "quantityCustomer", size: null, display: true },
    { value: "initialCount", size: null, display: true },
    { value: "quantity", size: null, display: true },
    { value: "quantityDone", size: null, display: true },
    { value: "quantityPosted", size: null, display: true },
    { value: "mobileReconditioningStatus", size: null, display: true },
    { value: "RECON_OVERALL", size: null, display: true },
    { value: "quantityDefectDokaDone", size: null, display: true },
    { value: "quantityDefectDokaPosted", size: null, display: true },
    { value: "quantityDefectCustomerDone", size: null, display: true },
    { value: "quantityDefectCustomerPosted", size: null, display: true },
    { value: "receptionYardIdentifier", size: null, display: true },
    { value: "doneWeight", size: null, display: true },
    { value: "RECON_SPAREPART_CLEANING", size: null, display: true },
    { value: "RECON_SPAREPART_FRAME_REPAIR", size: null, display: true },
    { value: "RECON_SPAREPART_OVERALL", size: null, display: true },
    { value: "additionalText", size: null, display: true },
  ];
  reconSparePartColumns: { value: string; size: string; display: boolean }[] = [
    { value: "articleIdentifier", size: null, display: true },
    { value: "articleName", size: null, display: true },
    { value: "quantityDone", size: null, display: true },
    { value: "quantityPosted", size: null, display: true },
    { value: "quantity", size: null, display: true },
    { value: "condition", size: null, display: true },
  ];
  openItemColumns: { value: string; size: string; display: boolean }[] = [
    { value: "articleIdentifier", size: null, display: true },
    { value: "articleName", size: null, display: true },
    { value: "status", size: null, display: true },
    { value: "quantity", size: null, display: true },
    { value: "quantityDone", size: null, display: true },
    { value: "initialCount", size: null, display: true },
    { value: "quantityCustomer", size: null, display: true },
    { value: "plannedFinishDate", size: null, display: true },
    { value: "type", size: null, display: true },
    { value: "reconditioningOrderIdentifier", size: null, display: true },
    { value: "customer", size: null, display: true },
    { value: "customerIdentifier", size: null, display: true },
    { value: "project", size: null, display: true },
    { value: "jobSite", size: null, display: true },
    { value: "additionalText", size: null, display: true },
  ];
  yardStockColumns: { value: string; size: string; display: boolean }[] = [
    { value: "articleIdentifier", size: null, display: true },
    { value: "serialNumberIdentifier", size: null, display: true },
    { value: "articleName", size: null, display: true },
    { value: "yardIdentifier", size: null, display: true },
    { value: "quantityNew", size: null, display: true },
    { value: "quantityUsed", size: null, display: true },
    { value: "tonnage", size: null, display: true },
  ];
  returnDeliveryColumns: { value: string; size: string; display: boolean }[] = [
    { value: "returnDeliveryIdentifier", size: null, display: true },
    { value: "customerName", size: null, display: true },
    { value: "projectIdentifier", size: null, display: true },
    { value: "projectName", size: null, display: true },
    { value: "returnDeliveryType", size: null, display: true },
    { value: "expectedReturnDeliveryDate", size: null, display: true },
    { value: "status", size: null, display: true },
    { value: "unloadingLocation", size: null, display: true },
    { value: "progress", size: null, display: true },
    { value: "users", size: null, display: true },
    { value: "tonnage1st", size: null, display: true },
    { value: "tonnage", size: null, display: true },
    { value: "additionalText", size: null, display: true },
  ];
  returnDeliveryItemColumns: { value: string; size: string; display: boolean }[] = [
    { value: "image", size: null, display: true },
    { value: "articleIdentifier", size: null, display: true },
    { value: "articleName", size: null, display: true },
    { value: "serialNumberIdentifier", size: null, display: true },
    { value: "quantityFirstSight", size: null, display: true },
    { value: "jobSite", size: null, display: true },
    { value: "quantityCustomerCount", size: null, display: true },
    { value: "quantityTotal", size: null, display: true },
    { value: "status", size: null, display: true },
    { value: "quantityOk", size: null, display: true },
    { value: "quantityRepair", size: null, display: true },
    { value: "quantityFinishedReconditioning", size: null, display: true },
    { value: "quantityWear", size: null, display: true },
    { value: "quantityDamaged", size: null, display: true },
    { value: "quantityOwnConsumption", size: null, display: true },
    { value: "additionalText", size: null, display: true },
  ];
  returnDeliverySparepartColumns: { value: string; size: string; display: boolean }[] = [
    { value: "articleIdentifier", size: null, display: true },
    { value: "articleName", size: null, display: true },
    { value: "serialNumberIdentifier", size: null, display: true },
    { value: "materialCondition", size: null, display: true },
    { value: "quantityDoka", size: null, display: true },
    { value: "quantityCustomer", size: null, display: true },
    { value: "reason", size: null, display: true },
    { value: "isIncluded", size: null, display: true },
  ];
  inboundOrderColumns: { value: string; size: string; display: boolean }[] = [
    { value: "inboundOrderIdentifier", size: null, display: true },
    { value: "purchaseType", size: null, display: true },
    { value: "purchaseOrderIdentifiers", size: null, display: true },
    { value: "plannedArrivalDate", size: null, display: true },
    { value: "mobileStatus", size: null, display: true },
    { value: "progress", size: null, display: true },
    { value: "location", size: null, display: true },
    { value: "remarks", size: null, display: true },
    { value: "carrierName", size: null, display: true },
    { value: "senderDeliveryNoteIdentifier", size: null, display: true },
    { value: "vendorName", size: null, display: true },
    { value: "processors", size: null, display: true },
    { value: "unloader", size: null, display: true },
    { value: "tonnage", size: null, display: true },
  ];
  inboundOrderItemColumns: { value: string; size: string; display: boolean }[] = [
    { value: "image", size: null, display: true },
    { value: "articleIdentifier", size: null, display: true },
    { value: "articleName", size: null, display: true },
    { value: "targetYardIdentifier", size: null, display: true },
    { value: "materialCondition", size: null, display: true },
    { value: "quantityOrdered", size: null, display: true },
    { value: "quantityOkNew", size: null, display: true },
    { value: "quantityOkUsed", size: null, display: true },
    { value: "quantityRepair", size: null, display: true },
    { value: "quantityDefect", size: null, display: true },
    { value: "mobileLineItemStatus", size: null, display: true },
    { value: "serialNumberIdentifier", size: null, display: true },
    { value: "remarks", size: null, display: true },
  ];
  returnHighlighting: string = "All";
  overviewFirst: Overview = Overview.DeliveryPicking;
  overviewSecond: Overview = Overview.DeliveryTransportOrder;
  overviewThird: Overview = Overview.ReturnDelivery;
  overviewFourth: Overview = Overview.Reconditioning;
  pickingSlide: PickingSlide = PickingSlide.Checked;
  measurementSystem: MeasurementSystem = MeasurementSystem.Metric;
}
